import Vue from 'vue'
import Vuex from 'vuex'
import{ MenuRouter } from '@/router'

Vue.use(Vuex)
export default new Vuex.Store({
  state: {
   	MenuRouter,
   	prjID:null,
    title:null,
    maxValue:null,
    minValue:null,
    imgsrc1:  localStorage.getItem('imageUrl'),
    imgsrc2: localStorage.getItem('imageUrl2'),
    canshudata:'终端信息',
  },
  getters :{
    //路由，用来生成目录
    MenuRouter :state => state.MenuRouter,
    canshudata:state=> state.canshudata,
    //当前工程ID
    prjID :state => state.prjID,
    // 存储最大值最小值
    maxValue:state=>state.maxValue,
    minValue:state=>state.minValue,
    //每个页面的标题
    title :state => {
      document.title =  state.title
      return state.title
    },
    //通过地址判断当前的系统是不是中性系统，从而改变登录页的图片，文字，以及布局
    mainSystem :() => {
      return window.location.host === "easc.chinajyy.net"||window.location.host === "114.220.73.67"||window.location.host === "192.168.99.163"||window.location.host === "192.168.9.31:8083"||window.location.host === "192.168.0.127:8083"||window.location.host === "192.168.0.9:8083"||window.location.host === "47.99.174.110"||window.location.host === "47.99.174.110:80"
      // return window.location.host === "easc.chinajyy.net"||window.location.host === "192.168.9.31:85"
    }
  },
  mutations :{
    changePrjID(state, prjID) {
      state.prjID = prjID
    },
    changeMaxValue(state,maxValue){
      state.maxValue = maxValue
    },
    changecanshudata(state,canshudata){
      state.canshudata = canshudata
    },
    
    changeMinValue(state,minValue){
      state.minValue = minValue
    },
    changeTitle(state,title) {
      state.title = title
    },
    changesrc1(state,imgsrc1){
      state.imgsrc1 = imgsrc1
    },
    changesrc2(state,imgsrc2){
      state.imgsrc2 = imgsrc2
    }
  }
})


// WEBPACK FOOTER //
// ./src/store/store.js